import { render, staticRenderFns } from "./TopTenConsumeItem.vue?vue&type=template&id=ac6034f8"
import script from "./TopTenConsumeItem.vue?vue&type=script&lang=js"
export * from "./TopTenConsumeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports